import { render, staticRenderFns } from "./AuthorityManagementLogin.vue?vue&type=template&id=5f105634&scoped=true&"
import script from "./authority_management_login.js?vue&type=script&lang=js&"
export * from "./authority_management_login.js?vue&type=script&lang=js&"
import style0 from "./AuthorityManagementLogin.vue?vue&type=style&index=0&id=5f105634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f105634",
  null
  
)

export default component.exports